module.exports = __webpack_public_path__ + "img/99ba24a.svg";